import { render, staticRenderFns } from "./myUmUploadImg.vue?vue&type=template&id=06b729ae&scoped=true&"
import script from "./myUmUploadImg.vue?vue&type=script&lang=js&"
export * from "./myUmUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./myUmUploadImg.vue?vue&type=style&index=0&id=06b729ae&prod&lang=scss&"
import style1 from "./myUmUploadImg.vue?vue&type=style&index=1&id=06b729ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b729ae",
  null
  
)

export default component.exports